export default __webpack_public_path__ + "static/media/ReportListNoReports.e3b644de.svg";